// @flow
import React, {Suspense, type Node} from 'react';

import {Loader} from 'components/__helpers/loader/loader';

import s from './withSuspense.scss';

// 102+52
// where
// 102 - height of the header and money back guaranty top strip
// 50 - margin inside the loader container
const MARGIN_TO_HIDE_FOOTER_ON_DEVICE_SCREEN = 152;

export const LoaderComponent = (
    <div style={{height: `${window.innerHeight - MARGIN_TO_HIDE_FOOTER_ON_DEVICE_SCREEN}px`}}>
        <Loader className={s.loader} />
    </div>
);

export const FullScreenLoader = () => LoaderComponent;

/**
 * HOC for generating suspense wrapper.
 * @param {React.Component} Element - Component.
 * @returns {React.StatelessComponent} Element
 * @constructor
 */
export const withSuspense = (Element: any) => (props: any = {}): Node => (
    <Suspense fallback={LoaderComponent}>
        <Element {...props} />
    </Suspense>
);
